var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleArrow = function SvgDoubleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#275AE6",
    d: "M19.508 8.811L11.188.492c-.656-.656-1.72-.656-2.376 0-.656.656-.656 1.72 0 2.377l7.13 7.13-7.13 7.13c-.656.656-.656 1.72 0 2.377.656.656 1.72.656 2.377 0l8.319-8.32c.656-.654.656-1.718 0-2.375zM9.505 8.308L2.9 1.346c-.664-.698-1.739-.698-2.402 0-.664.7-.664 1.832 0 2.532l5.404 5.695L.498 15.27c-.664.698-.664 1.833 0 2.531.663.699 1.738.699 2.402 0l6.605-6.961c.663-.699.663-1.832 0-2.531z"
  })));
};
export default SvgDoubleArrow;